<template>
	<div class="faqContent">
		<div class="contentWarp">
			<div class="title">{{contentData.title}}</div>
			<div class="content" v-html="contentData.content"></div>
			<ercode></ercode>
		</div>
		
	</div>
</template>

<script>
	import { get, isPC } from 'assets/api/config'
	import ercode from 'components/ercode'
	
	var img = {};
	
	export default {
		data() {
		    return {
		    	images:img,
		    	contentData:'',
		    }
		},
	 	activated() {
	 		console.log(this.$route.params.id)
	 		let that = this;
			//游戏详情
			let requestParams = {
				act: 'webInstructionContent',
				token: this.$route.params.id,
		    }
			
			get(requestParams).then(function(res) {
				that.contentData = res.data;
				console.log(res)
			});
		},
	  	methods: {
	  		toContent(id){
	  			
	  		}
	  	},
	  	components: {
		    ercode
	 	},
	}
</script>

<style lang="less">
	.faqContent{
		background:#f7f7f7;
		min-height: 100vh;
		
		.contentWarp{
			position: relative;
			padding: 56PX 30PX 0 30PX;
			margin: 0 auto;
			width: 608PX;
			min-height: 100vh;
			background-color: #fff;
		}
		
		.title{
			margin-bottom:56PX;
			font-size:26PX;
			color:#000;
			text-align: center;
		}
		
		.content{
			font-size:20PX;
			line-height: 32PX;
			color:#666;
			text-align: left;
			width: 100%;
			
			img{
				width: 100%;
				margin: 16PX 0;
				border-radius: 30PX;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/faqPC/content.vue